/**
 * MenuLoadingFallback
 *
 * The menu board's chrome with its body still loading, shown during the
 * token/auth handshake.
 *
 * The brand bar renders for real — it is the same on every board, waiting on
 * nothing. The body is {@link MenuSkeleton}, imported from `MenuDisplay` rather
 * than copied: this file used to carry a duplicate of that markup with a comment
 * saying the two were "kept in sync", which is a promise nothing enforced. A
 * board is read from across a room, so a body that changes shape mid-load is
 * conspicuous in a way it is not on a laptop.
 *
 * One definition means the three states a board passes through — auth loading,
 * menu-data loading, loaded — are layout-invariant by construction.
 */

import { MenuSkeleton } from './menu/MenuDisplay';

export function MenuLoadingFallback() {
  return (
    <div className="menu-display" role="status" aria-label="Loading menu" aria-busy>
      {/* Brand bar — static chrome. */}
      <div className="menu-display__header">
        <div className="menu-display__header-content">
          <div className="menu-display__brand-bar">
            <span className="menu-display__brand-name">Menu</span>
          </div>
        </div>
      </div>

      <MenuSkeleton />
      <span className="sr-only">Loading menu…</span>
    </div>
  );
}
